import { FC } from 'react';
import { PageSizer } from '../page/PageSizer';
import { BackgroundImage } from './BackgroundImage';
import { FadeColor, FadeTrapezium } from './FadeTrapezium';

interface SmallBackgroundProps {
  imageUrl: string;
  className: string;
}

export const SmallBackground: FC<SmallBackgroundProps> = ({ className, imageUrl }) => {
  return (
    <div className={className}>
      <div className="bg-primary-50 h-full w-[70%] top-0 left-0 absolute" />
      <div className="bg-primary-800 h-full w-[30%] top-0 right-0 absolute" />
      <PageSizer className="h-full z-[2] relative">
        <div className="w-[60%] translate-x-[100%] relative h-full overflow-hidden">
          <FadeTrapezium className="w-1/6 h-full absolute top-0 left-[-1px] z-[100]" fadeColor={FadeColor.LIGHT} />
          <FadeTrapezium reverse slant={5} className="hidden sm:block w-5/6 h-full absolute top-0 right-[-4px] z-[100]" fadeColor={FadeColor.DARK} />
          <FadeTrapezium reverse slant={5} className="sm:hidden w-[200%] h-full absolute top-0 left-[10%] z-[100]" fadeColor={FadeColor.DARK} />
          <BackgroundImage src={imageUrl} className="absolute w-[99%] left-1 h-full" />
        </div>
      </PageSizer>
    </div>
  );
};
